/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RmaRoofTestDto } from './rmaRoofTestDto';
import { RmaInspectionDto } from './rmaInspectionDto';
import { RmaIntakeDto } from './rmaIntakeDto';
import { RmaAllocationDto } from './rmaAllocationDto';
import { RmaDispatchDto } from './rmaDispatchDto';
import { CustomerDeclarationDto } from './customerDeclarationDto';
import { RmaItemDtoDisposition } from './rmaItemDtoDisposition';


export interface RmaItemDto { 
    id: string;
    status: RmaItemDto.StatusEnum;
    declaration: CustomerDeclarationDto;
    intake?: RmaIntakeDto;
    inspection?: RmaInspectionDto;
    disposition?: RmaItemDtoDisposition;
    allocation?: RmaAllocationDto;
    roofTest?: RmaRoofTestDto;
    dispatch?: RmaDispatchDto;
}
export namespace RmaItemDto {
    export const StatusEnum = {
        AwaitingArrival: 'AWAITING_ARRIVAL',
        Arrived: 'ARRIVED',
        Identified: 'IDENTIFIED',
        IntakeCompleted: 'INTAKE_COMPLETED',
        Inspected: 'INSPECTED',
        AwaitingAllocation: 'AWAITING_ALLOCATION',
        AwaitingConfiguration: 'AWAITING_CONFIGURATION',
        ConfigurationSubmitted: 'CONFIGURATION_SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Tested: 'TESTED',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        IntakeFailed: 'INTAKE_FAILED',
        Stored: 'STORED',
        Disposed: 'DISPOSED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


